/**
 * Remoting XPAC API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DeviceSortOrder = 'installationDate' | 'firstCloudDate' | 'name' | 'city' | 'country' | 'deviceId' | 'firmwareVersion' | 'activeProblems';

export const DeviceSortOrder = {
    InstallationDate: 'installationDate' as DeviceSortOrder,
    FirstCloudDate: 'firstCloudDate' as DeviceSortOrder,
    Name: 'name' as DeviceSortOrder,
    City: 'city' as DeviceSortOrder,
    Country: 'country' as DeviceSortOrder,
    DeviceId: 'deviceId' as DeviceSortOrder,
    FirmwareVersion: 'firmwareVersion' as DeviceSortOrder,
    ActiveProblems: 'activeProblems' as DeviceSortOrder
};

